/* eslint-disable max-len */
import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./managerFeedbackOnReportQuestionsIds";

export const managerFeedbackOnReportQuestionsMasterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.LanguageClearAndConcise,
        questionText: "Was the language in the report clear and concise?",
        canBeDisabled: false
    },
    {
        id: questionIds.ReportAnswersAllTheQuestions,
        questionText: "Did the report answer all the questions that you asked in the referral?",
        canBeDisabled: false
    },
    {
        id: questionIds.ReportSpecificEnough,
        questionText: "Was the report specific enough to meet your needs?",
        canBeDisabled: false
    },
    {
        id: questionIds.WereRecommendationsRealistic,
        questionText: "Were the recommendations that were made realistic in terms of implementation? If they were not realistic please provide further comments.",
        canBeDisabled: false
    },
    {
        id: questionIds.WereRecommendationsRealisticFurtherComments,
        questionText: "Please provide further comments",
        canBeDisabled: false
    },
    {
        id: questionIds.HowAccurateWasReturnToWorkDate,
        questionText: "If the member of staff was OFF work at the time of the referral, how accurate was the predicted return to work date provided in the report?",
        canBeDisabled: false
    },
    {
        id: questionIds.OverallExperience,
        questionText: "Overall, how has your experience with occupational health been, with 1 being terrible and 10 being excellent.",
        canBeDisabled: false
    },
    {
        id: questionIds.FurtherComments,
        questionText: "Please provide any further comments about the service you have received or your answers above:",
        canBeDisabled: false
    },
    {
        id: questionIds.FeedbackContactConsent,
        questionText: "We may from time to time choose to contact people about the feedback they have provided. If you do NOT want us to contact you about this feedback, please tick here",
        canBeDisabled: false
    }
];
